import React, { useState, useEffect } from 'react';
import { Card ,Button,Accordion} from 'react-bootstrap';
import RequestManager from "../../singletons/RequestManager";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';

function UnsubscribeCategory(props) {

    const [buttonDisabled, setButtonDisabled] = useState(false);
   
    
   
    async function categoryunsubscribe(catid,storeid,categoryName) {

        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure you want to deactivate this category '+ categoryName +'and all its child categories & products? Please confirm',
            buttons: [
              {
                label: 'Yes',
                onClick: async() =>{
                    console.log("yes")
                    let   param = {
                        input: {
                            categoryId: catid,
                            storeId:storeid,
                            status: "INACTIVE"
                           
                        }
                    }
                    console.log('from unsubscribe', param);
                    let requestManager = new RequestManager();

                    let response = await requestManager.getResponseFromPredefinedQuery(
                        "updateCategoryMerchantStore",
                        param
                    );  
                    console.log(response,"response")
            
                    // console.log(paramsvalue,"paramss")
                    setButtonDisabled(true);
                       
                   }
                },
              {
                label: 'No',
                onClick: () => console.log("no")
              }
            ]
          });



    }
   
    return (
       <React.Fragment>
            {/* {displaymesg &&
            <div className="alert alert-success">
            <strong>{displaymesg}</strong>
            </div>
                  } */}
                  {!buttonDisabled && (
             <Button className="float-right" disabled={buttonDisabled}   onClick={() => categoryunsubscribe(props.categoriesid,props.storeid,props.categoryname)} 
               variant="outline-success" >Unsubscribe</Button>
               )}
                  {buttonDisabled && (
             <Button className="float-right"  
               variant="outline-secondary" >INACTIVE</Button>
               )}
       </React.Fragment>
        
    )
}

export default UnsubscribeCategory



// WEBPACK FOOTER //
// ./src/components/subscribecategory/UnsubscribeCategory.js